'use client';

import { NumberFormats as nf, useCurrencyFormatter } from '@shared/utils';
import { ProgressBar } from '../../../ProgressBar/ProgressBar';
import { ProgressLabel } from '../../../ProgressBar/components/ProgressLabel';

import type { ComponentProps } from 'react';
import type { PromotionProgress } from '../../../types';

type PromotionProgressBarProps = ComponentProps<'div'> &
  PromotionProgress & {
    balanceText?: string;
    progressText: string;
    showBalance?: boolean;
  };

function PromotionProgressBar(props: PromotionProgressBarProps) {
  const { balance, progress, balanceText, progressText, showBalance = true, ...rest } = props;

  const currencyFormatter = useCurrencyFormatter();

  return (
    <div className="w-full bg-container p-3 paragraph-s-strong rounded-md" {...rest}>
      {showBalance && balanceText && (
        <div className="flex items-center justify-between" data-testid="promotion-progress-bar-balance-section">
          <span data-testid="promotion-progress-bar-balance-text">{balanceText}</span>
          <span data-testid="promotion-progress-bar-balance-amount">{currencyFormatter(balance).format(nf.WITH_DECIMALS).get()}</span>
        </div>
      )}
      {progress && progressText ? (
        <ProgressBar
          progress={progress}
          labelLeft={progressText}
          trackColour="bg-container-secondary"
          labelRight={<ProgressLabel progress={progress} format={progress.labelFormat || 'remainingOfMax'} formatAsCurrency={progress.isCurrency ?? showBalance} />}
        />
      ) : null}
    </div>
  );
}

export { PromotionProgressBar, type PromotionProgressBarProps };
